export const UnitActivityViewName = 'UnitActivityView';
